import React from 'react';
import Tabs from '@mui/material/Tabs';
import {useParams} from 'react-router-dom';

import LockTab from './LockTab';
import './LockTabsNavigation.scss';
import LockHistory from "../LockHistory/LockHistory";
import LockPendingWithdrawals from "../LockPendingWithdrawals/LockPendingWithdrawals";
import {depositWithdrawalLockStore} from "../../../../services/deposit-withdrawal-lock/deposit-withdrawal-lock.store";

const LockTabValue = {
    HISTORY: 'nrs-locking_history',
    PENDING_WITHDRAWALS: 'nrs-locking_pending-withdrawals',
}

const LockTabsNavigation = () => {

    const {  tab: routeTab, subTab = 'history' } = useParams();
    const currentTab = `${routeTab}_${subTab}` || LockTabValue.HISTORY

    return (
        <div className="LockTabsNavigation">
            <Tabs value={currentTab} TabIndicatorProps={{
                style: {
                    display: 'none'
                }
            }}>
                <LockTab label="History"
                         to={`/earn/nrs-locking/history`}
                         value={LockTabValue.HISTORY}
                />
                <LockTab label={`Pending Withdrawals${depositWithdrawalLockStore.pendingWithdrawalsCount ? ' (' + depositWithdrawalLockStore.pendingWithdrawalsCount + ')' : ''}`}
                         to={`/earn/nrs-locking/pending-withdrawals`}
                         value={LockTabValue.PENDING_WITHDRAWALS}
                />
            </Tabs>
            {currentTab === LockTabValue.HISTORY && <LockHistory />}
            {currentTab === LockTabValue.PENDING_WITHDRAWALS && <LockPendingWithdrawals />}
        </div>
    );
};

export default LockTabsNavigation;